<div class="w-100">
    <div class="container-fluid p-0">
        <div class="row">
            <div class="d-flex align-items-center gap-2 111 my-3 flex-wrap">
                <div class="d-flex gap-2 flex-wrap">
                    <div style="width: 450px;">
                        <input pInputText class="w-100 input-ui" filterButton left="10%" dir="rtl" type="text"
                            [(ngModel)]="searchText" placeholder="بحث" (input)="filterQuestionBanks(1)" />
                    </div>
                    <div class="pppp-drop">
                        <p-dropdown filterButton [options]="ministries" [(ngModel)]="dropMinistry" optionLabel="label"
                            appendTo="body" (onChange)="onChangeDropdown()"
                            [placeholder]="'Select Ministry' | translator"></p-dropdown>
                    </div>
                    <div class="pppp-drop" *ngIf="currentQBank?.standard != undefined ||currentQBank?.standard == true">
                        <p-dropdown filterButton [options]="types" [(ngModel)]="dropType" optionLabel="label"
                            appendTo="body" (onChange)="onChangeDropdown()"
                            [placeholder]="'Select Type' | translator"></p-dropdown>
                    </div>
                    <button class="v4-btn-every" (click)="resetFilters()">
                        <i class="pi pi-refresh"></i>
                    </button>
                </div>
                <button class="v4-btn-every p-07"
                    *ngIf="currentQBankId == standardQBID? hasPermission('GENERAL_QB', 'a') : true"
                    (click)="openCreateModal = true">
                    <i class="pi pi-plus-circle v4-ml-2"></i>{{ "New Topic" | translator }}
                </button>
                <div class="assesment-details">
                    <div class="miniheading 1"><span class="f-normal">{{'Total Questions' | translator}}
                            &nbsp;:&nbsp;</span> <span class="f-bold">{{ filteredQBService.length || 0 }}</span></div>
                    <div class="miniheading 2"><span class="f-normal">{{'Total Sub Questions' | translator}}
                            &nbsp;:&nbsp; </span><span class="f-bold">{{ getSubTotalService(filteredQBService) }}</span>
                    </div>
                </div>
                <!-- <div class="d-flex gap-2" style="margin-top: 15px;">
                    <div class="minisbutton">
                        <h5 class="miniheading">
                            {{'Total Questions' | translator}} : {{ filteredQBService.length || 0 }}
                        </h5>
                    </div>
                    <div class="minisbutton">
                        <h5 class="miniheading">
                            {{'Total Sub Questions' | translator}} : {{ getSubTotalService(filteredQBService) }}
                        </h5>
                    </div>
                </div> -->
                <div class="active-panel ml-3">
                    <h5 class="heading textt-900 tab" [class.active]="QBTab === 'Service'"
                        (click)="ChangeQBTab('Service', $event)">
                        {{ "Service" | translator }}
                    </h5>
                    <h5 class="heading textt-900 tab" [class.active]="QBTab === 'Topic'"
                        (click)="ChangeQBTab('Topic', $event)">
                        {{ "Topic" | translator }}
                    </h5>
                </div>

                <div class="active-panel" *ngIf="QBTab === 'Service'">
                    <h5 class="heading textt-900 tab" [class.active]="topicView === 'non_sample_topic'"
                        (click)="changeTopicView('non_sample_topic', $event)">
                        {{ "Non Sample Topics" | translator }}
                    </h5>
                    <h5 class="heading textt-900 tab" [class.active]="topicView === 'sample_topic'"
                        (click)="changeTopicView('sample_topic', $event)">
                        {{ "Sample Topics" | translator }}
                    </h5>
                </div>
            </div>



            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                <!-- <div class="active-panel">
                    <h5 class="heading textt-900 mx-2 mt-2 tab" [class.active]="QBTab === 'Service'"
                        (click)="ChangeQBTab('Service', $event)">
                        {{ "Service" | translator }}
                    </h5>
                    <h5 class="heading textt-900 mx-2 mt-2 tab" [class.active]="QBTab === 'Topic'"
                        (click)="ChangeQBTab('Topic', $event)">
                        {{ "Topic" | translator }}
                    </h5>
                </div> -->
                <div *ngIf="QBTab == 'Service'">
                    <!-- <div class="d-flex align-items-center justify-content-between gap-2 111 my-3 flex-wrap">
                        <button class="v4-btn-every p-07"
                            *ngIf="currentQBankId == standardQBID? hasPermission('GENERAL_QB', 'a') : true"
                            (click)="openCreateModal = true">
                            <i class="pi pi-plus-circle v4-ml-2"></i>{{ "New Topic" | translator }}
                        </button>
                        <div class="d-flex gap-2" style="margin-top: 15px;">
                            <div class="minisbutton">
                                <h5 class="miniheading">
                                    {{'Total Questions' | translator}} : {{ filteredQBService.length || 0 }}
                                </h5>
                            </div>
                            <div class="minisbutton">
                                <h5 class="miniheading">
                                    {{'Total Sub Questions' | translator}} : {{ getSubTotalService(filteredQBService) }}
                                </h5>
                            </div>
                        </div>
                        <div class="d-flex gap-2">
                            <div style="width: 450px;">
                                <input pInputText class="w-100" filterButton left="10%" dir="rtl" type="text"
                                    [(ngModel)]="searchText" placeholder="بحث" (input)="filterQuestionBanks(1)" />
                            </div>
                            <div class="pppp-drop">
                                <p-dropdown filterButton [options]="ministries" [(ngModel)]="dropMinistry"
                                    optionLabel="label" appendTo="body" (onChange)="onChangeDropdown()"
                                    [placeholder]="'Select Ministry' | translator"></p-dropdown>
                            </div>
                            <div class="pppp-drop"
                                *ngIf="currentQBank?.standard != undefined ||currentQBank?.standard == true">
                                <p-dropdown filterButton [options]="types" [(ngModel)]="dropType" optionLabel="label"
                                    appendTo="body" (onChange)="onChangeDropdown()"
                                    [placeholder]="'Select Type' | translator"></p-dropdown>
                            </div>
                            <button class="v4-btn-every" (click)="resetFilters()">
                                <i class="pi pi-refresh"></i>
                            </button>
                        </div>
                    </div> -->
                    <div *ngIf="filteredQBService.length <= 0" class="mt-2">
                        <app-no-data></app-no-data>
                    </div>
                    <div class="row w-100" *ngIf="filteredQBService.length > 0">
                        <div class="col-lg-12 col-md-12 col-12 p-0 111" style="min-height: 385px">

                            <p-accordion [multiple]="true" [activeIndex]="[0]">
                                <p-accordionTab *ngFor="let topic of filteredQBService">
                                    <ng-template class="d-flex justify-content-between" pTemplate="header">
                                        <div class="d-flex justify-content-between w-100">
                                            <div class="d-flex align-items-center">
                                                <div class="minisbutton d-flex align-items-center gap-2"
                                                    *ngIf="topic?.data[0]?.ministry?.label">
                                                    <img src="{{ staticFileUrl + topic?.data[0]?.ministry?.icon }}"
                                                        class="ministry-logo" />
                                                    <!-- <h5 class="miniheading 3">
                                                {{ topic?.data[0]?.ministry?.label }}
                                            </h5> -->
                                                </div>
                                                <h5 *ngIf="
                                        currentQBankId == standardQBID
                                        ? hasPermission('GENERAL_QB', 'a')
                                        : true
                                    " class="qbl-heading mx-2 11">

                                                    {{ topic.name }}
                                                </h5>
                                            </div>
                                            <div class="d-flex align-items-center gap-4">
                                                <h5 *ngIf="!hasPermission('GENERAL_QB', 'a')" class="qbl-heading 22">
                                                    {{ topic.name }}
                                                </h5>
                                                <div class="miniheading-7 d-flex align-items-center gap-2 4">
                                                    <div class="blue-circle">{{ (topic.questions) ?
                                                        topic.questions.length : 0}}</div>
                                                    <div class="">:{{'Sub Questions' | translator}}</div>
                                                </div>
                                                <span *ngIf="
                              currentQBankId == standardQBID
                                ? hasPermission('GENERAL_QB', 'a')
                                : true
                            ">
                                                    <p-menu #menu [model]="menuItems" [popup]="true"
                                                        appendTo="body"></p-menu>
                                                    <p-button
                                                        *ngIf="topic.questionBankId != standardQBID || currentQBankId == standardQBID"
                                                        class="v4-ui" styleClass="p-button-rounded p-button-text"
                                                        (onClick)="openTypeMenu(menu, $event, topic)"
                                                        icon="pi pi-ellipsis-v"></p-button>
                                                </span>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <p class="m-0" [innerHTML]="topic.description"></p>

                                        <div class="button-container">
                                            <div class="service-button">
                                                <button [disabled]="!topic.service" (click)="launchUrl(topic.service)"
                                                    [ngClass]="{
                                                    'v4-btn-every-dis': !topic.service, 
                                                    'v4-btn-every': topic.service
                                                }">
                                                    <i class="pi pi-external-link v4-ml-2"></i>{{ "Service" | translator
                                                    }}
                                                </button>
                                            </div>
                                            <div class="service-button">
                                                <button
                                                    *ngIf=" currentQBankId == standardQBID ? hasPermission('GENERAL_QB', 'a') : true "
                                                    [routerLink]="['/topic/add-question/', topic._id]" [queryParams]="{
                                                    QBankId: currentQBankId,
                                                    tabIndex: activeTabIndex,
                                                    QBTab:QBTab,
                                                }" class="v4-btn-every">
                                                    <i class="pi pi-external-link v4-ml-2"></i>
                                                    {{ "Add Question to QuestionBank" | translator }}
                                                </button>
                                            </div>
                                            <!-- <span *ngIf="
                              currentQBankId == standardQBID
                                ? hasPermission('GENERAL_QB', 'a')
                                : true
                            ">
                                                <p-menu #menu [model]="menuItems" [popup]="true"
                                                    appendTo="body"></p-menu>
                                                <p-button
                                                    *ngIf="topic.questionBankId != standardQBID || currentQBankId == standardQBID"
                                                    class="v4-ui" styleClass="p-button-rounded p-button-text"
                                                    (onClick)="openTypeMenu(menu, $event, topic)"
                                                    icon="pi pi-ellipsis-v"></p-button>
                                            </span> -->
                                        </div>


                                    </ng-template>
                                </p-accordionTab>

                            </p-accordion>










                            <!-- <div class="qbl-card"> -->

                            <!-- <h5 *ngIf="
                                        currentQBankId == standardQBID
                                        ? hasPermission('GENERAL_QB', 'a')
                                        : true
                                    " class="qbl-heading" [routerLink]="['/topic/add-question/', topic._id]" [queryParams]="{
                                        QBankId: currentQBankId,
                                        tabIndex: activeTabIndex,
                                        QBTab:QBTab
                                    }">

                                    {{ topic.name }}
                                </h5>
                                <h5 *ngIf="!hasPermission('GENERAL_QB', 'a')" class="qbl-heading">
                                    {{ topic.name }}
                                </h5> -->
                            <!-- <span class="qbl-column my-3">
                                    <p class="mb-0 qbl-p" [innerHTML]="topic.description"
                                        (click)="openTopicDialog(topic)"
                                        style="overflow: hidden;text-overflow: ellipsis;height: 12rem;"></p>
                                </span> -->
                            <!-- <div class="minisbutton d-flex gap-2" *ngIf="topic?.data[0]?.ministry?.label">
                                    <img src="{{ staticFileUrl + topic?.data[0]?.ministry?.icon }}"
                                        class="ministry-logo" />
                                    <h5 class="miniheading">
                                        {{ topic?.data[0]?.ministry?.label }}
                                    </h5>
                                </div> -->
                            <!-- <div class="minisbutton d-flex gap-2">
                                    <h5 class="miniheading">
                                        {{'Sub Questions' | translator}} : {{ (topic.questions) ? topic.questions.length
                                        : 0}}
                                    </h5>
                                </div> -->
                            <!-- <div class="button-container">
                                    <div class="service-button">
                                        <button [disabled]="!topic.service" (click)="launchUrl(topic.service)"
                                            [ngClass]="{
                                            'v4-btn-every-dis': !topic.service, 
                                            'v4-btn-every': topic.service
                                        }">
                                            <i class="pi pi-external-link v4-ml-2"></i>{{ "Service" | translator }}
                                        </button>
                                    </div>
                                    <div class="service-button">
                                        <button
                                            *ngIf=" currentQBankId == standardQBID ? hasPermission('GENERAL_QB', 'a') : true "
                                            [routerLink]="['/topic/add-question/', topic._id]" [queryParams]="{
                                            QBankId: currentQBankId,
                                            tabIndex: activeTabIndex,
                                            QBTab:QBTab
                                        }" class="v4-btn-every">
                                            <i class="pi pi-external-link v4-ml-2"></i>{{ "Add Question to QuestionBank"
                                            | translator }}
                                        </button>
                                    </div>
                                    <span *ngIf="
                      currentQBankId == standardQBID
                        ? hasPermission('GENERAL_QB', 'a')
                        : true
                    ">
                                        <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                                        <p-button
                                            *ngIf="topic.questionBankId != standardQBID || currentQBankId == standardQBID"
                                            class="v4-ui" styleClass="p-button-rounded p-button-text"
                                            (onClick)="openTypeMenu(menu, $event, topic)"
                                            icon="pi pi-ellipsis-v"></p-button>
                                    </span>
                                </div> -->
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
                <div *ngIf="QBTab == 'Topic'">
                    <div class="d-flex align-items-center justify-content-between gap-2 222 flex-wrap">
                        <button class="v4-btn-every my-3 p-07" *ngIf="
                currentQBankId == standardQBID
                  ? hasPermission('GENERAL_QB', 'a')
                  : true
              " (click)="openCreateModal = true">
                            <i class="pi pi-plus-circle"></i>{{ "New Topic" | translator }}
                        </button>
                        <div class="d-flex gap-2" style="margin-top: 15px;">
                            <div class="minisbutton">
                                <h5 class="miniheading 5">
                                    {{'Total Questions' | translator}} : {{ filteredQBTopics.length || 0 }}
                                </h5>
                            </div>
                            <div class="minisbutton">
                                <h5 class="miniheading 6">
                                    {{'Total Sub Questions' | translator}} : {{ getSubTotalTopic(filteredQBTopics) }}
                                </h5>
                            </div>
                        </div>
                        <div class="d-flex gap-2">
                            <input dir="rtl" filterButton class="ms-input-view" type="text" [(ngModel)]="searchText"
                                placeholder="بحث" (input)="filterQuestionBanks(2)" />
                            <div class="pppp-drop">
                                <p-dropdown filterButton [options]="topics" [(ngModel)]="dropTopic" optionLabel="name"
                                    appendTo="body" (onChange)="onChangeDropdown()"
                                    [placeholder]="'Select Topic' | translator"></p-dropdown>
                            </div>
                            <div class="pppp-drop" *ngIf="
                  currentQBank?.standard != undefined ||
                  currentQBank?.standard == true
                ">
                                <p-dropdown filterButton [options]="types" [(ngModel)]="dropType" optionLabel="label"
                                    appendTo="body" (onChange)="onChangeDropdown()"
                                    [placeholder]="'Select Type' | translator"></p-dropdown>
                            </div>
                            <button class="v4-btn-every" (click)="resetFilters()">
                                <i class="pi pi-refresh"></i>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="filteredQBTopics.length <= 0" class="mt-2">
                        <app-no-data></app-no-data>
                    </div>
                    <div class="row w-100" *ngIf="filteredQBTopics.length > 0">
                        <div class="col-lg-3 col-md-6 col-12 p-0" *ngFor="let topic of filteredQBTopics">
                            <div class="qbl-card">
                                <h5 *ngIf="
                    currentQBankId == standardQBID
                      ? hasPermission('GENERAL_QB', 'a')
                      : true
                  " class="qbl-heading 33" [routerLink]="['/topic/add-question/', topic._id]" [queryParams]="{
                    QBankId: currentQBankId,
                    tabIndex: activeTabIndex,
                    QBTab:QBTab
                  }">
                                    {{ topic.name }}
                                </h5>
                                <h5 *ngIf="!hasPermission('GENERAL_QB', 'a')" class="qbl-heading 44">
                                    {{ topic.name }}
                                </h5>

                                <span class="qbl-column my-3">
                                    <p class="mb-0 qbl-p" [innerHTML]="topic.description"
                                        (click)="openTopicDialog(topic)" style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      height: 12rem;
                    "></p>
                                </span>
                                <div class="minisbutton d-flex align-items-center gap-2"
                                    *ngIf="topic?.questionBankTopic[0]?.name">
                                    <h5 class="miniheading 7">
                                        {{ topic?.questionBankTopic[0]?.name }}
                                    </h5>
                                </div>
                                <div class="minisbutton d-flex align-items-center gap-2">
                                    <h5 class="miniheading 8">
                                        {{'Sub Questions' | translator}} : {{ (topic.questions) ? topic.questions.length
                                        : 0}}
                                    </h5>
                                </div>
                                <!-- *ngIf="topic.questionBankId != standardQBID" -->
                                <div class="button-container">
                                    <span *ngIf="
                      currentQBankId == standardQBID
                        ? hasPermission('GENERAL_QB', 'a')
                        : true
                    ">
                                        <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body"></p-menu>
                                        <p-button class="v4-ui" styleClass="p-button-rounded p-button-text"
                                            (onClick)="openTypeMenu(menu, $event, topic)"
                                            icon="pi pi-ellipsis-v"></p-button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 d-flex align-items-center justify-content-end gap-2 mt-2">
            <button class="v4-btn-every" (click)="showPrintModal = true;selectionPrint = true">
                <i class="pi pi-print v4-ml-2"></i>
                {{'Print Selection'|translator}}</button>
            <button class="v4-btn-every" (click)="showPrintModal = true">
                <i class="pi pi-print v4-ml-2"></i>
                {{'Print Questions'|translator}}</button>

            <button style="display: none;" #printButton [useExistingCss]="true"
                [printStyle]="{'#print-data':{'display':'block'},'*':{'direction': 'rtl'},'html':{'direction': 'rtl'},'body':{'direction': 'rtl'}}"
                printSectionId="print-data" ngxPrint>
                <i class="pi pi-print font-500 font-1_2rem"></i>
            </button>
        </div>
    </div>
</div>

<p-dialog [blockScroll]="true" [draggable]="false" [header]="selectedTopic?.name" [(visible)]="expandedTopic"
    [style]="{ width: '70vw', minHeight: '60vh' }" [maximizable]="true">
    <ng-template pTemplate="body">
        <h3 class="my-3">{{ "Description" | translator }}:</h3>
        <div [innerHTML]="selectedTopic?.description | safeHTML"></div>
    </ng-template>
</p-dialog>

<!-- Select Topics Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" [header]="selectedTopic?.name" [(visible)]="showSelectTopicsModal"
    [style]="{ width: '100vw', minHeight: '100vh' }" [maximizable]="true">
    <ng-template pTemplate="body">
        <div class="row">
            <p-checkbox [label]="'select all' | translator" type="checkbox" name="select-all" [binary]="true"
                [(ngModel)]="selectAllTopics" (ngModelChange)="selectAllPrintable()" />
            <div class="col-lg-2 col-md-6 col-12 p-0 my-2" *ngFor="let topic of printableData">
                <div class="qbl-card">
                    <h5 class="qbl-heading 55">
                        {{ topic.name }}
                    </h5>
                    <span class="qbl-column my-3">
                        <p class="mb-0 qbl-p" [innerHTML]="topic.description" (click)="openTopicDialog(topic)"
                            style="overflow: hidden;text-overflow: ellipsis;height: 12rem;"></p>
                    </span>
                    <div class="minisbutton d-flex align-items-center gap-2" *ngIf="topic?.ministry?.label">
                        <img src="{{ staticFileUrl + topic?.ministry?.icon }}" class="ministry-logo" />
                        <h5 class="miniheading 9">
                            {{ topic?.ministry?.label }}
                        </h5>
                    </div>
                    <div class="button-container">
                        <div class="service-button">
                            <button [disabled]="!topic.serviceId" (click)="launchUrl(topic.serviceId)"
                                class="v4-btn-every">
                                <i class="pi pi-external-link v4-ml-2"></i>{{ "Service" | translator }}
                            </button>
                        </div>
                        <span>
                            <p-checkbox name="Topics" [value]="topic"
                                [(ngModel)]="selectedPrintableTopics"></p-checkbox>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button styleClass="v4-btn-every" [loading]="loadingPrint" [disabled]="selectedPrintableTopics.length <= 0"
            [label]="'Print Questions'|translator" icon="pi pi-print"
            (onClick)="structureSelectedPrintableDataAndPrint()"></p-button>
    </ng-template>
</p-dialog>

<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="updateModal"
    [style]="{ margin: '0rem 1rem' }">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{ "Update Topic" | translator }}</span>
    </ng-template>
    <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
        (sendData)="UpdateData($event)"></app-dynamic-form>
</p-dialog>

<!-- Create new Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="Header" [(visible)]="openCreateModal"
    [style]="{ margin: '0rem 1rem' }">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{"Create a Topic"| translator}}</span>
    </ng-template>
    <app-dynamic-form [questions]="questions" (sendData)="receiveData($event)"></app-dynamic-form>
</p-dialog>


<!-- Print Criteria Modal -->
<p-dialog [blockScroll]="true" [draggable]="false"
    [header]=" (selectionPrint) ? ('Print Selection'|translator) : ('Print Questions'|translator) "
    [(visible)]="showPrintModal" (onHide)="resetPrintableState()" [style]="{width: '40vw' , minHeight:'30vh'}">
    <ng-template pTemplate="body">
        <form [formGroup]="printCriteriaForm">

            <div class="mb-3">
                <input dir="rtl" class="ms-input-view" type="text" formControlName="title"
                    placeholder="{{'Title' | translator}}" />
            </div>

            <div formArrayName="criteriaArray">
                <div class="d-flex align-items-start justify-content-between gap-3" style="margin-bottom:.5rem"
                    *ngFor="let criteria of ministriesCriteria.controls;let i=index" [formGroupName]="i">
                    <div class="w-100">
                        <p-dropdown formControlName="ministryId" styleClass="w-100" [options]="ministries"
                            optionLabel="label" appendTo="body" optionValue="_id"
                            [placeholder]="'Select Ministry' | translator "></p-dropdown>
                        <div style="color: red;" *ngIf="displayError('required',criteria.get('ministryId'))">
                            {{'Ministry is required'|translator}}.
                        </div>
                    </div>

                    <div class="w-100">
                        <p-inputNumber formControlName="count" styleClass="w-100"
                            [placeholder]="'Number of questions'|translator" />
                        <div style="color: red;" *ngIf="displayError('required',criteria.get('count'))">
                            {{'Count is required' | translator}}.
                        </div>
                    </div>

                    <p-button class="v4-ui" (onClick)="removePrintCriteria(i)" icon="pi pi-trash"
                        styleClass="input-button p-button-rounded p-button-danger p-button-text"></p-button>
                </div>
            </div>
        </form>
        <div style="margin-top: 1rem;">
            <p-button class="v4-ui" (onClick)="addPrintCriteria()" icon="pi pi-plus"
                styleClass="input-button p-button-text p-button-rounded p-button-outlined"></p-button>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button styleClass="v4-btn-every" [loading]="loadingPrint"
            [disabled]="!printCriteriaForm.valid || loadingPrint"
            [label]=" (selectionPrint) ? ('Print Selection'|translator) : ('Print Questions'|translator) "
            icon="pi pi-print" (onClick)="printQuestions()"></p-button>
    </ng-template>
</p-dialog>

<!-- Printing Service Use Only -->
<div id="print-data" style="display: block;width: 100%;background-color: white;"
    *ngIf="printableData && printableData.length > 0 && showPrintData">


    <!-- First Title Page -->
    <div class="front-page" style="width: 100%; height: 100%; display: grid;
    background-size: cover; background-position: center bottom; background-repeat: no-repeat;"
        [style.background-image]="'url(../../../assets/printback-'+ random(0,6).toString() +'.jpg)'">

        <div style="margin-top: 20px;place-self: flex-start;padding: 20px;">
            <img src="../../../assets/sbc_logo.svg" style="height: 50px" class="img-fluid">
        </div>

        <div
            style="text-align: center; display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <h2 style="font-weight: bold;line-height: 2; text-wrap: nowrap; color: #2B2A66;">
                {{'Assessments Question Bank'|translator}}
            </h2>
        </div>

        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" viewBox="0 0 595.24 230.9"
            style="enable-background:new 0 0 595.24 230.9; place-self: end; width: 100vw" xml:space="preserve">
            <style type="text/css">
                .st0 {
                    fill: #2B2A66;
                }

                .st1 {
                    fill: #792C82;
                }

                .st2 {
                    fill: #FFFFFF;
                }

                .st3 {
                    font-weight: 800;
                }

                .st4 {
                    font-size: 33.5162px;
                }

                .st5 {
                    font-weight: 800;
                }

                .st6 {
                    font-size: 15.962px;
                }

                .st7 {
                    fill: none;
                    stroke: #C391C1;
                    stroke-width: 6;
                    stroke-linecap: round;
                    stroke-miterlimit: 10;
                    stroke-dasharray: 11.6048, 13.539;
                }
            </style>
            <rect x="95.04" y="119.99" class="st0" width="500.21" height="110.91" />
            <path class="st1" d="M0,77.71l94.94-65.86c10.99-7.05,23.64-11.09,36.68-11.68c35.37-1.59,99.95,6.38,98.09,86.17
      c-0.52,22.48-8.39,44.18-21.96,62.11l-95.55,82.32L0.21,230.9L0,77.71z" />

            <!-- Rectangle as the bounding box -->
            <rect #boundingBox x="86.15" y="75.96" width="100" height="56" fill="none" stroke="none" />

            <ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.7337 128.4215)" cx="130.15" cy="75.96" rx="56"
                ry="56" class="st7"></ellipse>
            <text transform="matrix(1 0 0 1 162.5192 68.1995)" class="st2 st3 st6">
                {{"Print Items" | translator}}
            </text>
            <!-- <text transform="matrix(1 0 0 1 169.437 111.5614)" class="st2 st5 st6" clip-path="url(#textClip)">{{currentTypeFilter_arabic}}</text> -->

            <!-- Text element with clip-path to ensure it stays within the rectangle -->
            <text #dynamicText transform="matrix(1 0 0 1 162.437 111.5614)" class="st2 st5 st4"
                clip-path="url(#textClip)">
                <!-- {{currentTypeFilter_arabic}} -->
                {{printQuestionCount}}
            </text>

        </svg>

    </div>

    <!-- Indexes -->
    <div style="background-color: white;padding: 50px;width: 100%; height: 100%;color: black;">

        <h1 style="text-align: center; width: 100%;">{{"Table of contents" | translator}}</h1>

        <div *ngFor="let viewData of printableData; let ministryIndex = index"
            style="margin-bottom: 10px;background-color: white;">

            <div style="display: flex; align-items: center;">
                <p style="font-weight: bold;line-height: 2; color: #27306F;" [innerText]="viewData?.ministry?.label">
                </p>
            </div>

            <div *ngFor="let topic of viewData.data; let topicIndex = index"
                style="margin-left: 20px; margin-bottom: 5px;">

                <div style="display: flex; align-items: center;">
                    <div style="width:10%; margin-left: 5px;">
                        {{ministryIndex+1}}.{{topicIndex+1}}</div>
                    <div style="width:60%">{{ topic.name }}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Content with title page -->
    <div *ngFor="let view of printableData" style="page-break-before: always;background-color: white;">

        <div class="front-page" style="width: 100%; height: 100%; display: grid; 
            background-size: cover; background-position: center bottom; background-repeat: no-repeat;"
            [style.background-image]="'url(../../../assets/printback-'+ random(0,6).toString() +'.jpg)'">

            <div style="margin-top: 20px;place-self: flex-start;padding: 20px;">
                <img src="../../../assets/sbc_logo.svg" style="height: 50px" class="img-fluid">
            </div>

            <div
                style="text-align: center; display: flex; flex-direction: row; justify-content: center; align-items: center;color: black;">

                <img src="{{GlobalConstants.staticFilesURL + view?.ministry?.icon}}"
                    *ngIf="checkisImg(view?.ministry?.icon); else elseBlock"
                    style="height: 50px; width: auto; margin:20px" class="img-fluid">
                <ng-template #elseBlock>
                    <i class="pi pi-{{view?.ministry?.icon}} img-fluid"></i>
                </ng-template>
                <h2 style="font-weight: bold;line-height: 2; text-wrap: nowrap; color: #2B2A66;">
                    {{view?.ministry?.label}}
                </h2>
            </div>

            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 595.24 230.9"
                style="enable-background:new 0 0 595.24 230.9; place-self: end; width: 100vw" xml:space="preserve">
                <style type="text/css">
                    .st0 {
                        fill: #2B2A66;
                    }

                    .st1 {
                        fill: #792C82;
                    }

                    .st2 {
                        fill: #FFFFFF;
                    }

                    .st3 {
                        font-weight: 800;
                    }

                    .st4 {
                        font-size: 33.5162px;
                    }

                    .st5 {
                        font-weight: 800;
                    }

                    .st6 {
                        font-size: 15.962px;
                    }

                    .st7 {
                        fill: none;
                        stroke: #C391C1;
                        stroke-width: 6;
                        stroke-linecap: round;
                        stroke-miterlimit: 10;
                        stroke-dasharray: 11.6048, 13.539;
                    }
                </style>
                <rect x="95.04" y="119.99" class="st0" width="500.21" height="110.91" />
                <path class="st1" d="M0,77.71l94.94-65.86c10.99-7.05,23.64-11.09,36.68-11.68c35.37-1.59,99.95,6.38,98.09,86.17
              c-0.52,22.48-8.39,44.18-21.96,62.11l-95.55,82.32L0.21,230.9L0,77.71z" />

                <!-- Rectangle as the bounding box -->
                <rect #boundingBox x="86.15" y="75.96" width="100" height="56" fill="none" stroke="none" />

                <ellipse transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.7337 128.4215)" cx="130.15" cy="75.96"
                    rx="56" ry="56" class="st7"></ellipse>
                <text transform="matrix(1 0 0 1 162.5192 68.1995)" class="st2 st3 st6">
                    {{"Print Items" | translator}}
                </text>
                <!-- <text transform="matrix(1 0 0 1 169.437 111.5614)" class="st2 st5 st6" clip-path="url(#textClip)">{{currentTypeFilter_arabic}}</text> -->

                <!-- Text element with clip-path to ensure it stays within the rectangle -->
                <text #dynamicText transform="matrix(1 0 0 1 162.437 111.5614)" class="st2 st5 st4"
                    clip-path="url(#textClip)">
                    <!-- {{currentTypeFilter_arabic}} -->
                    {{view.data.length}}
                </text>

            </svg>

        </div>

        <ng-container *ngFor="let item of view.data; let i = index">
            <div style="page-break-before: always;background-color: white;width: 100%;height: 100%;color: black;">
                <div>
                    <h3 style="margin:10px">{{i+1}}
                    </h3>
                    <h2 class="card-title" style="font-weight: 600; color: #27306F;;margin-bottom: 2rem;">
                        {{item.name}}</h2>

                    <div style="margin:1rem 0;"></div>
                    <span class="hr"></span>

                    <div>
                        <div class="row" style="margin: 0.5rem 1rem">
                            <!-- For View -->
                            <div>
                                <div class="line-space mb-0 datacontent w-100"
                                    [innerHTML]="item.description | safeHTML">
                                </div>
                            </div>
                        </div>

                        <a [href]="getHostname() + '/data/'+item.serviceId" target="_blank" style="margin: 0.5rem 1rem">
                            {{getHostname() + '/data/'+item.serviceId}}
                        </a>

                        <div class="my-1" style="width: 250px;height: 250px;">
                            <qrcode [elementType]="'url'" [qrdata]="getHostname() + '/data/'+item.serviceId"
                                [errorCorrectionLevel]="'M'"></qrcode>
                        </div>

                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="print-footer"
        style="page-break-before: always; width: 100%; height: 100%; background-color: #28306F; display: grid; print-color-adjust: exact;">

        <img src="../../../assets/print_footer.png" style="place-self: center; width: 400px;">

    </div>
</div>